function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, ".st0{fill:#00e676;}");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "svg_1"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  id: "svg_2"
}, /*#__PURE__*/React.createElement("path", {
  d: "m46.46032,84.64921l-13.4,0l-13.4,0l-19,-19l0,-13.4l0,-13.4l19,-19l13.4,0l13.4,0l19,19l0,13.4l0,13.4l-19,19zm-13.5,-8l10.1,0l14.4,-14.3l0,-10.1l0,-10.1l-14.3,-14.4l-10.1,0l-10.1,0l-14.4,14.4l0,10.1l0,10.1l14.3,14.3l10.1,0z",
  id: "svg_3"
})), /*#__PURE__*/React.createElement("g", {
  id: "svg_4"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "m65.56032,65.44921l-13.4,0l-13.4,0l-19,-19l0,-13.4l0,-13.4l19,-19l13.4,0l13.4,0l19,19l0,13.4l0,13.4l-19,19zm-13.4,-8l10.1,0l14.3,-14.3l0,-10.1l0,-10.1l-14.3,-14.4l-10.1,0l-10.1,0l-14.4,14.3l0,10.1l0,10.1l14.3,14.3l10.2,0.1z",
  id: "svg_5"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  id: "svg_6"
}, /*#__PURE__*/React.createElement("path", {
  d: "m114.06032,33.99921l0,19.6c0,1.9 0.4,3.3 1.3,4.4c0.9,1 2.2,1.5 3.9,1.5c1.3,0 2.5,-0.3 3.6,-0.9c1.1,-0.6 2.2,-1.4 3.2,-2.4l0,-22.3l7.4,0l0,30.8l-4.5,0c-1,0 -1.6,-0.5 -1.9,-1.3l-0.5,-2.5c-0.6,0.6 -1.3,1.2 -2,1.8c-0.7,0.5 -1.4,1 -2.2,1.3c-0.8,0.4 -1.6,0.7 -2.5,0.9c-0.9,0.2 -1.8,0.3 -2.9,0.3c-1.7,0 -3.2,-0.3 -4.5,-0.9s-2.4,-1.4 -3.3,-2.4c-0.9,-1 -1.5,-2.3 -2,-3.7c-0.4,-1.4 -0.7,-3 -0.7,-4.7l0,-19.6l7.6,0l0,0.1z",
  id: "svg_7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m141.36032,64.79921l0,-30.8l4.5,0c1,0 1.6,0.5 1.9,1.4l0.5,2.4c0.6,-0.6 1.3,-1.2 2,-1.7c0.7,-0.5 1.4,-1 2.2,-1.3c0.8,-0.4 1.6,-0.7 2.5,-0.9c0.9,-0.2 1.8,-0.3 2.9,-0.3c1.7,0 3.2,0.3 4.5,0.9c1.3,0.6 2.4,1.4 3.3,2.4s1.5,2.3 2,3.7c0.5,1.4 0.7,3 0.7,4.7l0,19.6l-7.4,0l0,-19.6c0,-1.9 -0.4,-3.3 -1.3,-4.4c-0.9,-1 -2.2,-1.5 -3.9,-1.5c-1.3,0 -2.5,0.3 -3.6,0.9s-2.2,1.4 -3.2,2.4l0,22.3l-7.6,0l0,-0.2z",
  id: "svg_8"
}), /*#__PURE__*/React.createElement("path", {
  d: "m184.46032,25.09921c0,0.6 -0.1,1.2 -0.4,1.8c-0.3,0.6 -0.6,1 -1,1.5c-0.4,0.4 -0.9,0.8 -1.5,1c-0.6,0.2 -1.2,0.4 -1.9,0.4c-0.6,0 -1.2,-0.1 -1.8,-0.4c-0.6,-0.2 -1.1,-0.6 -1.5,-1c-0.4,-0.4 -0.8,-0.9 -1,-1.5c-0.3,-0.6 -0.4,-1.2 -0.4,-1.8c0,-0.7 0.1,-1.3 0.4,-1.9c0.2,-0.6 0.6,-1.1 1,-1.5s0.9,-0.8 1.5,-1c0.6,-0.2 1.2,-0.4 1.8,-0.4c0.7,0 1.3,0.1 1.9,0.4c0.6,0.3 1.1,0.6 1.5,1c0.4,0.4 0.8,0.9 1,1.5c0.3,0.6 0.4,1.2 0.4,1.9zm-1.1,8.9l0,30.8l-7.4,0l0,-30.8l7.4,0z",
  id: "svg_9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m193.06032,64.79921l0,-25.2l-2.7,-0.4c-0.6,-0.1 -1,-0.3 -1.4,-0.6c-0.4,-0.3 -0.5,-0.7 -0.5,-1.3l0,-3l4.6,0l0,-1c0,-1.9 0.3,-3.6 0.9,-5.2c0.6,-1.6 1.6,-3 2.8,-4.2c1.3,-1.2 2.9,-2.1 4.8,-2.8c1.9,-0.7 4.2,-1 6.8,-1c0.8,0 1.7,0 2.6,0.1c0.9,0.1 1.6,0.2 2.3,0.4l-0.2,3.8c0,0.5 -0.3,0.7 -0.8,0.8c-0.5,0.1 -1,0.1 -1.7,0.1c-1.9,0 -3.6,0.2 -4.9,0.5c-1.3,0.3 -2.4,0.8 -3.2,1.5s-1.4,1.5 -1.7,2.5c-0.4,1 -0.5,2.2 -0.5,3.5l0,0.8l19.1,0l0,30.5l-7.4,0l0,-25.2l-11.5,0l0,25.2l-7.4,0l0,0.2z",
  id: "svg_10"
})));

function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 220 85",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/LogoText.f9612fa7.svg";
export { ForwardRef as ReactComponent };